import { ApiResponse } from "./../../../../shared/models/appointment.model";
import { ApiService } from "./../../../../shared/services/api/api.service";
import { Component, Directive, HostListener, Output } from "@angular/core";
// import { GloDatePickerComponent } from '../../../shared/components/GloDatePickerComponent/';
// import { GloControlComponent } from "../../../shared/components/glo-control/glo-control.component";
import {
  FormBuilder,
  FormGroup,
  Validators,
  ReactiveFormsModule,
  FormControl,
} from "@angular/forms";
import { MatDialogRef } from "@angular/material/dialog";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import Swal from "sweetalert2";
import { GloDatePickerComponent } from "../../../../shared/components/glo-date-picker/glo-date-picker/glo-date-picker.component";
import { GloControlComponent } from "../../../../shared/components/glo-control/glo-control.component";
import { EventEmitter } from "@angular/core";
import { LoaderComponent } from "../../../../shared/components/loader/loader.component";
import { API_ENDPOINTS } from "../../../../shared/services/api/api-endpoints";
import { environment } from "../../../../../environments/environment";

interface SalonResponse {
  success: boolean;
  message: string;
  results: Salon[]; // backend sends salons here
}

interface Salon {
  salon_id: number;
  name: string;
  description: string;
  phone: string;
  email: string;
  address: string;
  city: string;
  created_at: string;
}

interface Service {
  duration_minutes: number;
  name: string;
  price: string;
  service_id: string;
}

interface Staff {
  email: string;
  full_name: string;
  is_active: boolean;
  job_title: string;
  staff_id: string;
}

interface Customer {
  full_name: string;
  customer_id: string;
}

interface DropDownResponse {
  customers: [];
  services: Service[];
  staff: Staff[];
}

@Component({
  selector: "app-appointments-add",
  imports: [
    GloDatePickerComponent,
    GloControlComponent,
    ReactiveFormsModule,
    LoaderComponent,
  ],
  templateUrl: "./appointments-add.component.html",
  styleUrl: "./appointments-add.component.scss",
})
export class AppointmentsAddComponent {
  @Output() appointmentCreated = new EventEmitter<void>();
  selectedDate: Date | null = null;
  AppointmentForm!: FormGroup;
  loading: boolean = false;
  isEditable: boolean = false;
  saloonId: string = "";
  Saloons: Salon[] = [];
  Services: Service[] = [];
  Staff: Staff[] = [];
  Customer: [] = [];

  assetUrl = environment.assetBaseUrl;

  timeSlots: { id: string; Name: string }[] = [
    { id: "12:00 AM", Name: "12:00 AM" },
    { id: "01:00 AM", Name: "01:00 AM" },
    { id: "02:00 AM", Name: "02:00 AM" },
    { id: "03:00 AM", Name: "03:00 AM" },
    { id: "04:00 AM", Name: "04:00 AM" },
    { id: "05:00 AM", Name: "05:00 AM" },
    { id: "06:00 AM", Name: "06:00 AM" },
    { id: "07:00 AM", Name: "07:00 AM" },
    { id: "08:00 AM", Name: "08:00 AM" },
    { id: "09:00 AM", Name: "09:00 AM" },
    { id: "10:00 AM", Name: "10:00 AM" },
    { id: "11:00 AM", Name: "11:00 AM" },
    { id: "12:00 PM", Name: "12:00 PM" },
    { id: "01:00 PM", Name: "01:00 PM" },
    { id: "02:00 PM", Name: "02:00 PM" },
    { id: "03:00 PM", Name: "03:00 PM" },
    { id: "04:00 PM", Name: "04:00 PM" },
    { id: "05:00 PM", Name: "05:00 PM" },
    { id: "06:00 PM", Name: "06:00 PM" },
    { id: "07:00 PM", Name: "07:00 PM" },
    { id: "08:00 PM", Name: "08:00 PM" },
    { id: "09:00 PM", Name: "09:00 PM" },
    { id: "10:00 PM", Name: "10:00 PM" },
    { id: "11:00 PM", Name: "11:00 PM" },
  ];

  constructor(
    private fb: FormBuilder,
    private dailogRef: MatDialogRef<AppointmentsAddComponent>,
    private http: HttpClient,
    private ApiService: ApiService,
  ) {
    this.AppointmentForm = this.fb.group({
      appointmentDate: [
        null,
        [
          Validators.required,
          (control: FormControl) => {
            const value = control.value;
            const regex = /^(0[1-9]|1[0-2])\/(0[1-9]|[12]\d|3[01])\/\d{4}$/;
            if (
              typeof value === "string" &&
              value.length !== 0 &&
              !regex.test(value)
            ) {
              return { pattern: true };
            }
            return null;
          },
        ],
      ],
      start_time: ["", Validators.required],
      saloonId: ["", Validators.required],
      customerId: ["", Validators.required],
      handleById: [""],
      service_ids: ["", Validators.required],
    });
  }

  ngOnInit() {
    this.LoadSaloons();
  }

  onAppointmentSuccess() {
    // After saving appointment successfully
    this.dailogRef.close("appointmentAdded");
  }

  get appointmentDate(): FormControl {
    return this.AppointmentForm.get("appointmentDate") as FormControl;
  }

  onChange(value: string, controlName: string) {
    if (controlName === "saloonId") {
      this.getDropDownData(value);
    }
    this.AppointmentForm.get(controlName)?.setValue(value);
  }

  onBlur() {
    this.appointmentDate.markAsTouched();
    this.appointmentDate.updateValueAndValidity();
  }

  onClosePopup() {
    this.dailogRef.close();
  }

  getAuthHeaders(): HttpHeaders {
    const token = localStorage.getItem("access_token");
    return new HttpHeaders({
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    });
  }

  LoadSaloons() {
    this.loading = true;
    this.ApiService.request(API_ENDPOINTS.salons.list, "GET").subscribe({
      next: (reponse: any) => {
        this.Saloons = reponse?.results;
        this.loading = false;
      },
      error: (error) => {
        console.log("FAILED TO FETCH SALOONS", error);
        this.loading = false;
      },
    });
  }

  getDropDownData(salonID: string) {
    this.loading = true;
    this.ApiService.request(
      API_ENDPOINTS.owner.salons.dropdowns(salonID),
      "GET",
    ).subscribe({
      next: (response: any) => {
        this.Services = response.services;
        this.Staff = response.staff;
        this.Customer = response.customers;
        this.loading = false;
        this.saloonId = salonID;
      },
      error: (error) => {
        this.loading = false;
      },
    });
  }

  // handleSubmit() {
  //   if (this.AppointmentForm.invalid) {
  //     this.AppointmentForm.markAllAsTouched();
  //     return;
  //   }
  //   this.loading = true
  //   let formData = { ...this.AppointmentForm.value }
  //   this.http.post(`http://127.0.0.1:8000/api/owner/salons/${this.saloonId}/appointments/`, formData, { headers: this.getAuthHeaders() }).subscribe({
  //     next: (response) => {
  //       Swal.fire({
  //         title: "Employee Updated!",
  //         text: "Employee saved successfully",
  //         icon: "success",
  //         timer: 5000,
  //         showConfirmButton: false,
  //         toast: true,
  //         position: "top-end",
  //       })
  //       this.dailogRef.close()
  //       this.loading = false
  //     },
  //     error: (error) => {
  //       Swal.fire({
  //         title: "Failed to save employee!",
  //         text: `Error: ${error}`,
  //         icon: "error",
  //         confirmButtonText: "Try Again",
  //       })
  //       this.loading = false
  //     }
  //   })
  //   console.log("Form submitted:", this.AppointmentForm.value);
  // }

  handleSubmit() {
    if (this.AppointmentForm.invalid) {
      this.AppointmentForm.markAllAsTouched();
      return;
    }
    this.loading = true;

    const formData = this.AppointmentForm.value;

    // ✅ transform payload
    const payload = {
      customer_id: formData.customerId,
      staff_id: formData.handleById,
      service_ids: Array.isArray(formData.service_ids)
        ? formData.service_ids
        : [formData.service_ids],
      start_time: formData.appointmentDate, // should already be ISO datetime
      notes: "Priority client", // default or from another input field
      payment_status: "pending",
      payment_method: "cash",
      status: "confirmed",
    };
    this.ApiService.request(
      API_ENDPOINTS.owner.appointments.createForSalon(this.saloonId),
      "POST",
      payload,
      "Appointment Created Successfully!",
    ).subscribe({
      next: () => {
        // 👇 Fire event here
        this.appointmentCreated.emit();
        this.dailogRef.close();
        this.loading = false;
      },
      error: (error) => {
        this.loading = false;
      },
    });
  }
}
